// The one identity of App's global toast. React keys the Toast on it, so a
// toast with the same type and message keeps the same instance, and the
// toast's own exit clears state only while state still shows that identity.
// A button that raises a toast with new text keeps it; a re-keyed copy of the
// same toast (the HBCF notice re-keyed on a first save) goes with the exit
// instead of sitting on an instance that is already leaving (review rounds 3-4,
// 2026-10-23).

type ToastLike = { type?: unknown; message?: unknown } | null | undefined;

export function toastKey(toast: ToastLike): string {
    return `${String(toast?.type || 'info')}::${String(toast?.message || '')}`;
}

/** The state after the toast shown as `shownKey` finishes its exit. */
export function afterToastExit<T extends ToastLike>(current: T, shownKey: string): T | null {
    return current && toastKey(current) === shownKey ? null : current;
}
